export default __webpack_public_path__ + "static/media/gallery_16.8f417012.jpg";